import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error',
  imports: [CommonModule,RouterModule,TranslateModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  standalone: true
})
export class ErrorComponent {
}
